import './index.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';

import { Provider } from 'react-redux';
import KeycloakProvider from 'react-lib/dist/keycloak-es';
import App from './App';
import { keycloakConfig } from './keycloak';
import LoadingComponent from './components/Loader/LoadingComponent';
import store from './store/store';

import './i18n';

const queryCache = new QueryCache();
const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: any) => {
        const { response } = error ?? {};
        if (response?.status === 403) {
          return false;
        }
        if (failureCount < 2) {
          return true;
        }
        return false;
      },
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <KeycloakProvider keycloakConfig={keycloakConfig} LoadingComponent={LoadingComponent}>
        <App />
      </KeycloakProvider>
    </QueryClientProvider>
  </Provider>
);
